import { render, staticRenderFns } from "./CustomFieldBoolean.vue?vue&type=template&id=3408b292&scoped=true"
import script from "./CustomFieldBoolean.vue?vue&type=script&lang=ts"
export * from "./CustomFieldBoolean.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldBoolean.vue?vue&type=style&index=0&id=3408b292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3408b292",
  null
  
)

export default component.exports